import React from 'react';
import { AiOutlinePercentage } from 'react-icons/ai';

import SettingsOption, { OptionType } from '../SettingsOption';
import { useFormikContext } from 'formik';
import { shouldEnableOrganizationFee } from 'legacy/events/helpers';

const EventOrganizerFee = () => {
  const { values, setFieldValue } = useFormikContext<any>();

  const toggleCommentsPermission = () => {
    setFieldValue('chargeOrganizationFee', !values.chargeOrganizationFee);
  };

  if (values?.groups?.length > 0) {
    return (
      <SettingsOption
        icon={<AiOutlinePercentage size={20} />}
        title="Event Organizer Fee"
        type={OptionType.Toggle}
        onClick={toggleCommentsPermission}
        disabled={!shouldEnableOrganizationFee(values?.groups)}
        isActive={values?.chargeOrganizationFee}
        tooltipMessage="Service fee charged by event organizer or venue"
        disabledTooltipMessage="Contact Bounce support (sales@bouncedinc.com) if you want to set an Event Organizer Fee."
      />
    );
  }

  return null;
};

export default EventOrganizerFee;
